/**
 * Save a Blob returned by an attachment endpoint to the user's disk.
 *
 * Every export flow repeats the same three steps — read the filename out of
 * Content-Disposition, click a temporary anchor, revoke the object URL — so they live
 * here once rather than in each hook.
 *
 * @param {Blob} blob            Response body from a `responseType: 'blob'` request.
 * @param {Object} headers       Axios response headers (for Content-Disposition).
 * @param {string} fallbackName  Used when the server sends no filename.
 */
export const saveBlobAsFile = (blob, headers = {}, fallbackName = 'download') => {
  const disposition = headers?.['content-disposition'] || '';
  const match = disposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
  const filename = match ? match[1].replace(/['"]/g, '').trim() : fallbackName;

  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = filename;
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  URL.revokeObjectURL(url);

  return filename;
};

export default saveBlobAsFile;
